// extracted by mini-css-extract-plugin
export default {"name":"Review_name__waBd+","jobTitle":"Review_jobTitle__OABYK","stars":"Review_stars__IKaAH","review":"Review_review__EfHsm","text":"Review_text__bJpN2"};